import React from 'react';

const KVKK: React.FC = () => {
  return (
    <div className="pt-32 pb-24 bg-background">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-display text-white mb-8 border-b border-border/20 pb-4">KVKK Aydınlatma Metni</h1>
        <div className="flex flex-col gap-6 text-sm text-muted-foreground leading-relaxed">
          <p><strong>Son Güncelleme:</strong> Temmuz 2026</p>
          <p>6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, veri sorumlusu sıfatıyla <strong>WE24 Agency</strong> olarak, siz değerli web sitesi ziyaretçilerimizin kişisel verilerini yasal sınırlar dahilinde işlemekteyiz.</p>
          
          <h3 className="text-lg font-bold text-white mt-4">1. Kişisel Verilerin Hangi Amaçla İşleneceği</h3>
          <p>Web sitemizdeki iletişim ve proje talep formları aracılığıyla toplanan bilgileriniz;</p>
          <ul className="list-disc pl-5 flex flex-col gap-2">
            <li>Talep ettiğiniz kreatif, prodüksiyon ve yazılım hizmetlerine yönelik süreçlerin planlanması,</li>
            <li>İletişim ve teklif sunma süreçlerinin yürütülmesi,</li>
            <li>Yasal yükümlülüklerin yerine getirilmesi amacıyla işlenmektedir.</li>
          </ul>

          <h3 className="text-lg font-bold text-white mt-4">2. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi</h3>
          <p>Kişisel verileriniz, sitemizi ziyaret etmeniz ve formları doldurmanız suretiyle tamamen elektronik ortamda toplanmaktadır. Bu veriler, KVKK'nın 5. maddesinde belirtilen fiili imtiyaz ve yasal yükümlülüklerin ifası hukuki sebeplerine dayanarak işlenir.</p>

          <h3 className="text-lg font-bold text-white mt-4">3. Veri Sahibi Olarak Haklarınız</h3>
          <p>KVKK'nın 11. maddesi uyarınca, veri sorumlusu olan ajansımıza başvurarak aşağıdaki haklarınızı kullanabilirsiniz:</p>
          <ul className="list-disc pl-5 flex flex-col gap-2">
            <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
            <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
            <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,</li>
            <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme,</li>
            <li>Kanuna uygun olarak silinmesini veya yok edilmesini talep etme.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default KVKK;
